// extracted by mini-css-extract-plugin
export default {"button":"Ar-z","reviewSort":"Br-z"};